import type { PageTour } from '../pageTour';
import { accessControlTour } from './accessControl';
import { alertActionsTour } from './alertActions';
import { alertBoardTour } from './alertBoard';
import { alertDetailTour } from './alertDetail';
import { alertsTour } from './alerts';
import { allSitesAlertBoardTour } from './allSitesAlertBoard';
import { allSitesLiveWallTour } from './allSitesLiveWall';
import { attendanceConfigTour } from './attendanceConfig';
import { attendanceEmployeesTour } from './attendanceEmployees';
import { attendancePayrollTour } from './attendancePayroll';
import { attendancePresenceTour } from './attendancePresence';
import { attendanceTimelineTour } from './attendanceTimeline';
import { attendanceUnknownFacesTour } from './attendanceUnknownFaces';
import { cameraConfigTour } from './cameraConfig';
import { cameraDetailTour } from './cameraDetail';
import { cameraGroupsTour } from './cameraGroups';
import { cameraImportTour } from './cameraImport';
import { cameraManagementTour } from './cameraManagement';
import { camerasTour } from './cameras';
import { dashboardTour } from './dashboard';
import { discoveryTour } from './discovery';
import { eventDetailTour } from './eventDetail';
import { heatmapTour } from './heatmap';
import { reportTour } from './report';
import { sitesTour } from './sites';
import { integrationsTour } from './integrations';
import { modelAssignmentsTour } from './modelAssignments';
import { modelsTour } from './models';
import { platformHealthTour } from './platformHealth';
import { recordingsTour } from './recordings';
import { searchTour } from './search';
import { siteDashboardTour } from './siteDashboard';
import { siteLiveWallTour } from './siteLiveWall';
import { siteSettingsTour } from './siteSettings';
import { siteWallPlaybackTour } from './siteWallPlayback';
import { systemAlertsTour } from './systemAlerts';
import { systemHealthTour } from './systemHealth';
import { turnMonitorTour } from './turnMonitor';
import { userManagementTour } from './userManagement';
import { watchListTour } from './watchList';

/**
 * Every page tour, one file per page. The first entry whose `match` accepts the current path
 * wins, so list a more specific route before a general one that would also match it
 * (e.g. `/reports/heatmap` before `/reports/:model`).
 */
export const PAGE_TOURS: PageTour[] = [
  accessControlTour,
  alertActionsTour,
  alertBoardTour,
  alertDetailTour,
  alertsTour,
  allSitesAlertBoardTour,
  allSitesLiveWallTour,
  attendanceConfigTour,
  attendanceEmployeesTour,
  attendancePayrollTour,
  attendancePresenceTour,
  attendanceTimelineTour,
  attendanceUnknownFacesTour,
  cameraConfigTour,
  cameraDetailTour,
  cameraGroupsTour,
  cameraImportTour,
  cameraManagementTour,
  camerasTour,
  dashboardTour,
  discoveryTour,
  eventDetailTour,
  heatmapTour,  // before reportTour: /reports/:model also matches /reports/heatmap
  reportTour,
  integrationsTour,
  modelAssignmentsTour,
  modelsTour,
  platformHealthTour,
  recordingsTour,
  searchTour,
  siteDashboardTour,
  sitesTour,
  siteLiveWallTour,
  siteSettingsTour,
  siteWallPlaybackTour,
  systemAlertsTour,
  systemHealthTour,
  turnMonitorTour,
  userManagementTour,
  watchListTour,
];

export function findPageTour(pathname: string): PageTour | null {
  return PAGE_TOURS.find((t) => t.match(pathname)) ?? null;
}
